"use strict";

export function initInScope ($scope) {
    if(!window.matchMedia("(pointer: coarse)").matches) {
        $scope.find('.js-color-hover__btn').on('mouseenter', function (e) {
            let hoverImageSrc = $(this).attr('data-color-hover');

            //$scope.find('.js-color-hover').attr('hidden',false);
            $scope.find('.js-color-hover').addClass('active');
            $scope.find('.js-color-hover__img').attr('src',hoverImageSrc);
        });

        $scope.find('.js-color-hover__btn').on('mouseleave', function (e) {
            //$scope.find('.js-color-hover').attr('hidden','hidden');
            $scope.find('.js-color-hover').removeClass('active');
        });
    }
}
